import { Typography } from "@mui/material";
import { Provider } from "src/api/types";
import WhiteCard from "src/components/WhiteCard";

interface Props {
  provider: Provider;
}
const ProviderInfo = ({ provider }: Props) => {
  return (
    <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
      <Typography variant="subtitle2">PROVIDER INFORMATION</Typography>
      <Typography>{`Id: ${provider.id}`}</Typography>
      <Typography>{`NPI: ${provider.npi_key}`}</Typography>
      <Typography>{`DEA: ${provider.dea_number}`}</Typography>
    </WhiteCard>
  );
};

export default ProviderInfo;
